"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var EndTimeInput_1 = __importDefault(require("./EndTimeInput"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
require("./styles.scss");
var Step1 = function (_a) {
    var setNextStep = _a.setNextStep;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var isNextStepDisabled = (0, react_1.useMemo)(function () { var _a; return ((_a = Object.keys(formState.errors || {})) === null || _a === void 0 ? void 0 : _a.length) > 0; }, [formState]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('coolingOff')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('coolingOffDescription')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description, style: { fontSize: '12px' } }, t('chooseTimeToPlanToTakeABreakFromGaming')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.onceSetCoolingOff }, t('onceSetTheCoolingOffPeriodCannotBeCanceledUntilExpire')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.durationContainer },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(react_final_form_1.Field, { name: "endDate", render: function (_a) {
                            var input = _a.input;
                            return (react_1.default.createElement("div", null,
                                react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, t('endDateOfTheBlock')),
                                react_1.default.createElement(ui_components_1.DatePicker, __assign({}, input, { disabledDaysBefore: true }))));
                        } })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(EndTimeInput_1.default, null)))),
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: function () {
                if (!isNextStepDisabled)
                    setNextStep();
            }, maxWidth: "335px", width: "100%", type: "button", disabled: isNextStepDisabled }, t('setLimit'))));
};
exports.default = Step1;
